import React from 'react';
import Teaser from 'components/FullTeaser/FullTeaser';
import { useSession } from 'next-auth/react';
import useFavoriteCmsItems from 'hooks/useFavoriteCmsItems';
import Link from 'components/AppSafeLink/AppSafeLink';
import Loading from 'components/Loading/Loading';
import ForYouInner from './ForYouInner';
import { useRouter } from 'next/router';
import { getServerSession } from 'next-auth';
import { authOptions } from 'pages/api/auth/[...nextauth]';
import type { GetServerSideProps } from 'next';

const ForYou = () => {
  const router = useRouter();
  const sessionData = useSession();
  const session = sessionData.data;

  const { favorites: favoriteCollections, isLoading } =
    useFavoriteCmsItems('collection');

  const isLoggedIn = Boolean(session?.user);

  if (!isLoggedIn) {
    return (
      <ForYouInner
        current="for-you"
        inner={<div>Please log in to view your favorites.</div>}
      />
    );
  }
  if (isLoading) {
    return <ForYouInner current="for-you" inner={<Loading />} />;
  }
  if (!isLoading && isLoggedIn && favoriteCollections.length < 1) {
    router.push('/for-you/following');
  }

  const Jsx = (
    <div className="for-you">
      <div className="container">
        <main>
          <div id="mainContent"></div>
          <div className="for-you-welcome">
            <h2>
              Welcome back{' '}
              {session?.user.given_name || session?.user.username || ''}
            </h2>
          </div>
          <div className="collection userContent">
            {favoriteCollections.length > 0 ? (
              <div className="for-you-items">
                {favoriteCollections.map((item) => (
                  <div className="for-you-item" key={item.id}>
                    <Teaser
                      item={item}
                      hideAddFavorites={true}
                      size="normal"
                      newspartners={false}
                      loading="lazy"
                      condensedBtns={false}
                      saveButtonBG={false}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div>
                Welcome to your personalized For You section, where MPR News
                meets your interests. Stay updated with the latest stories that
                matter most to you.{' '}
                <Link href="/for-you/following">
                  Start following your favorite topics today and never miss an
                  update!
                </Link>{' '}
                Want us to add a topic you think is missing from our current
                options? Let us know&nbsp;
                <a href="mailto:Tell@mpr.org">Tell@mpr.org</a>.{' '}
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
  return <ForYouInner current="for-you" inner={Jsx} />;
};

export const getServerSideProps = (async (context) => {
  const session = await getServerSession(context.req, context.res, authOptions);
  return {
    props: {
      session,
    },
  };
}) satisfies GetServerSideProps;
export default ForYou;
